import { Client } from "@/types";

type ClientEmailFields = Pick<Client, "email" | "emailAddresses">;
type ClientPhoneFields = Pick<Client, "phone" | "phoneNumbers">;

/**
 * The client's primary email address.
 *
 * Prefers the address flagged `primary` in `emailAddresses`, then the first
 * address, then the legacy `client.email` mirror, and finally an empty string.
 * Use this anywhere a single email must be displayed or sent for a client so
 * callers track the multi-address model instead of the denormalized mirror.
 */
export const getPrimaryEmail = (client: ClientEmailFields): string =>
  client.emailAddresses?.find((e) => e.primary)?.email ??
  client.emailAddresses?.[0]?.email ??
  client.email ??
  "";

/**
 * The client's primary phone number (raw, unformatted).
 *
 * Prefers the number flagged `primary` in `phoneNumbers`, then the first
 * number, then the legacy `client.phone` mirror, and finally an empty string.
 * Format the result with `formatPhoneNumber` for display.
 */
export const getPrimaryPhone = (client: ClientPhoneFields): string =>
  client.phoneNumbers?.find((p) => p.primary)?.number ??
  client.phoneNumbers?.[0]?.number ??
  client.phone ??
  "";
